/**
 *
 * @param filterElement
 */
const filters = (filterElement) => {
  if (!filterElement) {
    return;
  }

  const showMoreButton = filterElement.querySelector( 'button[aria-pressed]' );
  const showMoreItems = filterElement.querySelector( '.extra-terms' );
  const mobileToggleButton = filterElement.querySelector( 'button[aria-haspopup="true"]' );

  /**
   * Update the text of the show more button based on its state
   */
  const updateShowMoreButtonText = () => {
    if (!showMoreButton) {
      return;
    }
    const isPressed = showMoreButton.getAttribute( 'aria-pressed' ) === 'true';
    const showMoreButtonText = showMoreButton.querySelector( 'span' );

    showMoreButtonText.textContent = isPressed ? 'Show less' : 'Show more';
    showMoreItems.style.display = isPressed ? 'flex' : 'none';
  };

  /**
   * Update the text of the mobile toggle button based on its state
   */
  const updateMobileToggleButtonText = () => {
    if( ! mobileToggleButton ) {
      return;
    }

    const isExpanded = mobileToggleButton.getAttribute( 'aria-expanded' ) === 'true';
    const mobileToggleButtonText = mobileToggleButton.querySelector( 'span' );

    mobileToggleButtonText.textContent = isExpanded ? 'Hide filters' : 'Show filters';
  };

  /**
   * Toggle the show more items
   * @param event
   */
  const toggleShowMore = (event) => {
    event.preventDefault();

    const isPressed = showMoreButton.getAttribute( 'aria-pressed' ) === 'true';
    showMoreButton.setAttribute( 'aria-pressed', isPressed ? 'false' : 'true' );

    updateShowMoreButtonText();
  };

  /**
   * Toggle the mobile filter
   * @param event
   */
  const toggleMobileFilter = (event) => {
    if( ! mobileToggleButton ) {
      return;
    }

    event.preventDefault();

    const isExpanded = mobileToggleButton.getAttribute( 'aria-expanded' ) === 'true';
    mobileToggleButton.setAttribute( 'aria-expanded', isExpanded ? 'false' : 'true' );

    updateMobileToggleButtonText();
  };

  updateShowMoreButtonText();
  updateMobileToggleButtonText();

  showMoreButton?.addEventListener( 'click', toggleShowMore );
  mobileToggleButton?.addEventListener( 'click', toggleMobileFilter );
};

export default filters;
